<div class="search-overlay">
  <lib-search-box
    class="search-input"
    [value]="query()"
    (valueChange)="query.set($event)"
  />

  <ul class="results">
    <li class="list-item" *rxFor="let route of results$" [@staggerList] >
      <a class="link" [routerLink]="route.path" [@staggerItem] >
        <div class="label" [@fadeChild] >{{ route.title }}</div>
      </a>
    </li>
  </ul>
</div>